import { LayoutVerifications } from '@/components/hoc';
import { BodyPage, Controls } from './components';
import { useDocumentTitle } from '@/hooks';
import { BadgeCheck } from 'lucide-react';

const CertificationsPage = () => {

	useDocumentTitle({ title: 'Certifications' });

	return (
		<LayoutVerifications
			header={{
				description: 'Certification des comptes utilisateurs.',
				title: 'Certifications'
			}}
			breadcrumb={{ title: 'Certifications' }}
			icon={BadgeCheck}>
			<Controls />
			<BodyPage />
		</LayoutVerifications>
	);

};

export default CertificationsPage;
